import {isEqual} from 'lodash';
import React from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import {AutoSizer, CellMeasurer, CellMeasurerCache, List} from 'react-virtualized';
import 'react-virtualized/styles.css';
import NewUserCard from '../../Components/EventManagement/Matching/NewUserCard';
import {preventDefaultDrag} from '../../Utils/utils';
import './UserListStyles.scss';

class UsersList extends React.PureComponent {
    constructor(props) {
        super(props);
        this.cache = new CellMeasurerCache({
            // Define a CellMeasurerCache --> Put the height and width you think are the best
            defaultHeight: 80,
            fixedWidth: true,
        });
    }

    componentDidMount = () => {
        this.list.Grid._scrollingContainer = this.scroll.view;
    };

    componentDidUpdate = (prevProps) => {
        const {sortedByOnline, eventUsers} = this.props;
        if (prevProps.eventUsers.length !== eventUsers.length) {
            this.resizeList();
        }

        if (!isEqual(prevProps.eventUsers, eventUsers)) {
            this.resizeList();
        }

        if (prevProps.sortedByOnline !== sortedByOnline) {
            const scrollToTop = true;
            this.resizeList(scrollToTop);
        }
    };

    resizeList = (scrollToTop = false) => {
        this.cache.clearAll();
        if (this.list) {
            this.list.recomputeRowHeights();
            if (scrollToTop) {
                this.list.scrollToPosition();
            }
        }
    };

    handleScroll = (e) => {
        this.list.Grid._onScroll(e);
    };

    renderThumb = ({style, ...props}) => {
        const thumbStyle = {
            backgroundColor: `#777081`,
            left: 0,
            border: `1px solid #FFFFFF`,
            boxShadow: `0px 2px 4px rgba(0, 0, 0, 0.25)`,
            borderRadius: `8px`,
        };
        return (
            <div
                onDragStart={preventDefaultDrag}
                className="grey-scroll"
                style={{...style, ...thumbStyle}}
                {...props}
            />
        );
    };

    renderView = ({style, ...props}) => {
        let viewStyle = {};
        if (this.props.isRtlLanguage) {
            viewStyle = {...viewStyle, marginLeft: style.marginRight, marginRight: 0};
        }
        return <div onDragStart={preventDefaultDrag} className="box" style={{...style, ...viewStyle}} {...props} />;
    };

    rowRenderer = ({
        key, // Unique key within array of rows
        index, // Index of row within collection
        parent,
        style,
    }) => {
        const eventUser = this.props.eventUsers[index];
        return (
            <CellMeasurer cache={this.cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
                <div
                    className="Row"
                    key={key}
                    style={{
                        ...style,
                    }}
                >
                    <NewUserCard
                        noDialog
                        key={key}
                        userId={eventUser?.user}
                        userData={eventUser}
                        matchingLevel={eventUser?.matchingLevel}
                        showInviteToStageButton={this.props.showInviteToStageButton}
                    />
                </div>
            </CellMeasurer>
        );
    };

    render() {
        return (
            <AutoSizer>
                {({height, width}) => (
                    <Scrollbars
                        ref={(node) => (this.scroll = node)}
                        onScroll={this.handleScroll}
                        style={{height, width}}
                        className="scrollbar"
                        renderThumbVertical={this.renderThumb}
                        renderView={this.renderView}
                    >
                        <List
                            tabIndex={-1}
                            width={width}
                            height={height}
                            rowGetter={({index}) => this.props.eventUsers[index]}
                            rowCount={this.props.eventUsers.length}
                            rowHeight={this.cache.rowHeight}
                            rowRenderer={this.rowRenderer}
                            headerHeight={20}
                            style={{overflowX: 'visible', overflowY: 'visible'}}
                            ref={(node) => (this.list = node)}
                        />
                    </Scrollbars>
                )}
            </AutoSizer>
        );
    }
}
export default UsersList;
